import React, { useState } from 'react'; // ۱. اضافه کردن useState
import { FaPhoneAlt, FaSms, FaUserPlus, FaTrash, FaLightbulb, FaPlus, FaMinus } from "react-icons/fa";
import styles from '../../pages/Monitor/Monitor.module.css';

const GsmControlCard = ({ data, onUpdate }) => {
    // تعریف هوک‌ها
    const [newPhone, setNewPhone] = useState('');
    const [isExpanded, setIsExpanded] = useState(false); // ۲. وضعیت نمایش رله‌ها

    if (!data) return null;

    const { settings, triggered } = data;
    
    const numbers = settings?.learnedNumber ? settings.learnedNumber.split(',').filter(n => n.trim() !== "") : [];
    const activeRelays = settings?.callToDOut ? settings.callToDOut.split(',').map(Number).filter(n => !isNaN(n)) : [];

    const addNumber = () => {
        if (newPhone.trim().length >= 10 && !numbers.includes(newPhone.trim())) {
            const updatedList = [...numbers, newPhone.trim()].join(',');
            onUpdate('learnedNumber', updatedList);
            setNewPhone('');
        }
    };

    const removeNumber = (numToRemove) => {
        const updatedList = numbers.filter(n => n !== numToRemove).join(',');
        onUpdate('learnedNumber', updatedList);
    };

    const toggleRelay = (relayId) => {
        let newRelays;
        if (activeRelays.includes(relayId)) {
            newRelays = activeRelays.filter(r => r !== relayId);
        } else {
            newRelays = [...activeRelays, relayId].sort((a, b) => a - b);
        }
        onUpdate('callToDOut', newRelays.join(','));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') addNumber();
    };

    // ۳. منطق تعیین لیست رله‌های نمایشی
    const relayList = [...Array(isExpanded ? 72 : 8).keys()];

    return (
        <div className={styles.sensorCard} style={{ borderRight: '4px solid #3498db' }}>
            <div className={styles.cardHeader}>
                <div style={{ display: 'flex', alignItems: 'center', gap:'10px' }}>
                    <FaPhoneAlt color="#3498db" />
                    <span style={{ fontWeight: 'bold' }}>ماژول ارتباطی GSM</span>
                </div>
                <FaLightbulb 
                    className={`${styles.trigIcon} ${triggered ? styles.trigOn : styles.trigOff}`}
                    title={triggered ? "در حال دریافت تماس..." : "وضعیت آزاد"}
                    style={{ fontSize: '18px' }}
                />
            </div>

            <div className={styles.settingsGroup}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                    <div className={styles.settingRow} style={{ flex: 1 }}>
                        <span style={{ fontSize: '12px' }}>کنترل با تماس:</span>
                        <label className={styles.toggleSwitch}>
                            <input 
                                type="checkbox" 
                                checked={settings?.callEnableSecu === "1"} 
                                onChange={(e) => onUpdate('callEnableSecu', e.target.checked ? "1" : "0")} 
                            />
                            <span className={styles.slider}></span>
                        </label>
                    </div>
                    <div className={styles.settingRow} style={{ flex: 1 }}>
                        <span style={{ fontSize: '12px' }}>پیامک هشدار:</span>
                        <label className={styles.toggleSwitch}>
                            <input 
                                type="checkbox" 
                                checked={settings?.alertSms === "1"} 
                                onChange={(e) => onUpdate('alertSms', e.target.checked ? "1" : "0")} 
                            />
                            <span className={styles.slider}></span>
                        </label>
                    </div>
                </div>

                {/* بخش رله‌ها با دکمه نمایش بیشتر */}
                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start', marginTop: '10px' }}>
                    <span style={{ fontSize: '13px', color: '#3498db', marginBottom: '5px' }}>
                        اتصال به خروجی‌ها ({isExpanded ? '۰-۷۱' : '۰-۷'}):
                    </span>
                    <div style={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: '4px', 
                        padding: '6px',
                        background: 'rgba(0,0,0,0.15)',
                        borderRadius: '6px',
                        width: '100%',
                        border: '1px solid rgba(255,255,255,0.05)'
                    }}>
                        {relayList.map(r => (
                            <button 
                                key={r}
                                type="button"
                                onClick={() => toggleRelay(r)}
                                style={{
                                    width: '22px',
                                    height: '22px',
                                    fontSize: '9px',
                                    backgroundColor: activeRelays.includes(r) ? '#2ecc71' : '#34495e',
                                    border: 'none', 
                                    color: 'white', 
                                    borderRadius: '3px', 
                                    cursor: 'pointer',
                                    transition: '0.2s'
                                }}
                            >
                                {r}
                            </button>
                        ))}
                        
                        {/* ۴. دکمه نمایش بیشتر در کنار بقیه دکمه‌ها */}
                        <button 
                            type="button"
                            className={styles.retroToggleBtn} // از کلاسی که در CSS تعریف کردیم استفاده می‌کند
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? <FaMinus /> : <FaPlus />}
                        </button>
                    </div>
                    {activeRelays.length > 0 && (
                        <div style={{fontSize:'10px', color:'#95a5a6', marginTop:'5px'}}>
                            انتخاب شده: {activeRelays.join(', ')}
                        </div>
                    )}
                </div>

                <hr style={{ border: '0', borderTop: '1px solid #ffffff10', margin: '15px 0' }} />

                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ marginBottom: '8px', fontSize: '13px', color: '#3498db' }}>مدیریت شماره‌های مجاز:</span>
                    <div style={{ display: 'flex', width: '100%', gap: '5px' }}>
                        <input 
                            className={styles.inputNum} 
                            style={{ flex: 1, textAlign: 'left', padding: '0 8px', fontSize: '12px' }}
                            placeholder="0912..."
                            value={newPhone}
                            onChange={(e) => setNewPhone(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <button 
                            onClick={addNumber} 
                            style={{ background: '#2ecc71', border: 'none', color: 'white', padding: '5px 12px', borderRadius: '4px', cursor: 'pointer' }}
                        >
                            <FaUserPlus />
                        </button>
                    </div>
                    
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        width: '100%', 
                        gap: '5px', 
                        marginTop: '10px', 
                        maxHeight: '100px', 
                        overflowY: 'auto',
                        paddingRight: '5px'
                    }}>
                        {numbers.map(num => (
                            <div key={num} style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                background: 'rgba(255,255,255,0.05)', 
                                padding: '6px 10px', 
                                borderRadius: '4px', 
                                fontSize: '12px' 
                            }}>
                                <span style={{ fontFamily: 'monospace' }}>{num}</span>
                                <FaTrash 
                                    style={{ color: '#e74c3c', cursor: 'pointer', fontSize: '11px' }} 
                                    onClick={() => removeNumber(num)} 
                                />
                            </div>
                        ))}
                        {numbers.length === 0 && <small style={{ color: '#7f8c8d', textAlign: 'center', width: '100%' }}>لیست شماره‌ها خالی است</small>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GsmControlCard;